import Routes from '../../constants/routes';
import translation from '../../languages';
import { ChildElementType, OverlayTrigger } from '../../ui/overlay-trigger/overlay-trigger';
import Tooltip from '../../ui/tooltip';
import { RichTooltipAction } from '../../ui/tooltip/variations/rich-tooltip/rich-tooltip.types';
import cn from '../../utils/classnames';
import './quality-tooltip.scss';

type QualityTooltipProps = TranslationProps & {
    id: string;
    children: ChildElementType;
    className?: string;
    onLinkClick?: () => void;
};

const QualityTooltip = ({ id, children, className, onLinkClick, t }: QualityTooltipProps) => {
    const linkAction: RichTooltipAction = onLinkClick
        ? { title: t('qualityBadge.linkText'), onClick: onLinkClick }
        : { title: t('qualityBadge.linkText'), href: Routes.QUALITY_LANDING.path };

    return (
        <OverlayTrigger
            overlay={
                <Tooltip.Rich
                    id={id}
                    className={cn('quality-label-tooltip-wrapper', className)}
                    placement='bottom'
                    actions={[linkAction]}
                >
                    <span className='tooltip-text'>{t('qualityBadge.tooltipText')}</span>
                </Tooltip.Rich>
            }
            trigger={['click', 'hover']}
            placement='bottom-start'
        >
            {children}
        </OverlayTrigger>
    );
};

const translate = translation('quality');

export default translate(QualityTooltip);
